import React, { Component } from "react";
import axios from "../../../containers/api";
import { Row, Card, CardBody, Button, Collapse, FormGroup, Label, Input, Alert, Badge, ModalHeader, ModalBody, Modal, CardTitle } from "reactstrap";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import { Table } from "../../../components/table/Table";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import Config from "../../../constants/config";
import { convertDate, getDayBefore, showCatchError, toEnglishNumbers } from "../../../helpers/Utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export default class DriverTurnList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            DriverTurnList: [],
            PriorityList: [],
            PriorityModal: false,
            searchValue: "",
            Native: false,
            DriverTurnId: null,
            DriverCardNumber: "",
            fromDate: getDayBefore(),
            toDate: utils('fa').getToday(),
            loadHall: null,
            LoadHallList: [],
            priorityMsg: "",
            IsActive: [
                { value: 1, text: 'فعال' },
                { value: 0, text: 'غیرفعال' },
                { value: 2, text: 'همه' }
            ],
            selectedIsActive: { value: 1, text: 'فعال' },
            collapse: true,
            loadHall: null,
            LoadHallList: [],
        };
    }

    componentDidMount() {
    if (this.props.memberType.role !== 'LoadHallAdmin' )
        this.GetLoadHall()
    }
    GetLoadHall = () => {
        this.props.showSpinner()
        let api = '';
        if (this.props.memberType.role === 'Organization' || this.props.memberType.role === 'DriversAssociation' || this.props.memberType.role === 'AssociationTransportCompanies')
            api = 'load-hall-users/GetByUserId'
        else
            api = 'load-halls'
        axios.get('/api/v1/' + api) 
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ LoadHallList: res.data.data });
            })
            .catch((error) => {
                console.log(error)
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    

    SearchVirtualSalonDriverTurn = () => {
        
        if (this.props.memberType.role !== 'LoadHallAdmin' )
        if (this.state.loadHall === null || this.state.loadHall === "") {
            this.props.showAlert("لطفا سالن مورد نظر را انتخاب کنید", "error");
            return;
        } 
        let searchModel = {
            FromDate: convertDate(this.state.fromDate),
            ToDate: convertDate(this.state.toDate),
            IsActive: toEnglishNumbers(this.state.selectedIsActive.value),
            LoadHallId: this.props.memberType.role !== 'LoadHallAdmin'?this.state.loadHall != null ? this.state.loadHall.loadHallId : null: null,
            DriverCardNumber: (this.state.DriverCardNumber !== null && this.state.DriverCardNumber !== undefined && this.state.DriverCardNumber !== "") ? toEnglishNumbers(this.state.DriverCardNumber) : null,
            FreighterCardNumber: (this.state.FreighterCardNumber !== null && this.state.FreighterCardNumber !== undefined && this.state.FreighterCardNumber !== "") ? toEnglishNumbers(this.state.FreighterCardNumber) : null,
        };

        this.props.showSpinner();
        axios.post('/api/v1/driver-turns/SearchDriverTurn' , searchModel)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data.length != null && res.data.data.length > 0) {
                    this.setState({ DriverTurnList: res.data.data, collapse: false });
                } else {
                    this.setState({ DriverTurnList: [] });
                }
                

 
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error));
                console.log(error.response);
            })
    };

    clearSearch = () => {
        this.setState({
            fromDate: getDayBefore(),
            toDate: utils('fa').getToday(),
            DriverCardNumber: "",
            FreighterCardNumber: "",
            DriverTurnList: [],
            loadHall: null,
            selectedIsActive: { value: 2, text: 'همه' },
            loadHall: null,
          
        });
    };

    print = (DriverTurnId, format) => {
        this.props.showSpinner();
        axios.get('api/ReportApi/Search_VirtualSalonDriverTurn?DriverTurnId=' + DriverTurnId + '&ExportFormat=' + format,
            { responseType: "arraybuffer" })
            .then((res) => {
                this.props.hideSpinner();
                if (format === 'pdf') {
                    let blob = new Blob([res.data], { type: "application/pdf" });
                    let objectUrl = URL.createObjectURL(blob);
                    window.open(objectUrl);
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert("در چاپ خطايی رخ داده است", "error");
            });
    };

    GetByDriverTurnId = (DriverTurnId) => {
        
        let searchModel = {
            DriverTurnId: DriverTurnId,
            IsAll: true 
        };

        this.props.showSpinner();
        axios.post('/api/v1/driver-priorities/driver-active-priority', searchModel)
     
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    if (res.data.data.length != null && res.data.data.length > 0) {
                        this.setState({ PriorityList: res.data.data, priorityMsg: "" });
                    } else {
                        this.setState({ PriorityList: [], priorityMsg: "اولویتی وجود ندارد" });
                    }
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error));
                console.log(error.response);
            });
    };

    DeleteDriverPriority = ( DriverTurnId,Id) => {
        //let Model = {
        //    Id: Id,

        //};
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.delete(`/api/v1/driver-priorities/cancel/${Id}`)  
        //axios.post('/api/v1/driver-priorities/cancel', Model)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data.code !== 1 && res.data.data.code !== "1") {
                    this.props.showAlert(res.data.message, "error");
                } else {
                    this.props.showAlert(res.data.message, "success");
                    this.GetByDriverTurnId(DriverTurnId);
                }
              
                 
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error));
                console.log(error.response);
            });
    };
    CancelDriverTurn = (DriverTurnId) => {
        this.props.showSpinner();
        this.props.closeSweetAlert(); 
        axios.patch(`/api/v1/driver-turns/cancel/${DriverTurnId}`)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    this.props.showAlert(res.data.message, "success");
                    this.SearchVirtualSalonDriverTurn();
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error));
                console.log(error.response);
            });
    };
    selectHandleChange = (event, value, name) => {
        this.setState({ [name]: value });
    };

    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3> نوبت‌های رانندگان</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row>
                    <Colxx xxs="12" className="mb-4">
                        <Card>
                            <CardBody>
                            <CardTitle>جستجو</CardTitle> 

                                    <div className="p-4 pt-5 border d-flex flex-column">
                                        <div className="d-flex flex-md-row flex-column justify-content-center">
                                            <FormGroup className="w-md-30 w-100 px-1">
                                                <Label>از تاریخ</Label>
                                                <DatePicker
                                                    value={this.state.fromDate}
                                                    onChange={(newDate) => { this.setState({ fromDate: newDate }); }}
                                                    inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                                                    shouldHighlightWeekends
                                                    inputClassName="form-control"
                                                    locale="fa"
                                                    calendarClassName="calendar"
                                                    colorPrimary={Config.color}
                                                    calendarPopperPosition={'bottom'}
                                                />
                                            </FormGroup>

                                            <FormGroup className="w-md-30 w-100 px-1">
                                                <Label>تا تاریخ</Label>
                                                <DatePicker
                                                    value={this.state.toDate}
                                                    onChange={(newDate) => { this.setState({ toDate: newDate }); }}
                                                    inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                                                    shouldHighlightWeekends
                                                    inputClassName="form-control"
                                                    locale="fa"
                                                    calendarClassName="calendar"
                                                    colorPrimary={Config.color}
                                                    calendarPopperPosition={'bottom'}
                                                />
                                            </FormGroup>

                                            <FormGroup className="w-md-30 w-100 px-1">
                                                <Label>هوشمند راننده</Label>
                                                <Input value={this.state.DriverCardNumber} maxLength={11}
                                                    onChange={(e) => this.setState({ DriverCardNumber: e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                                            </FormGroup>
                                        </div>
                                            <div className="d-flex flex-md-row flex-column justify-content-center">
                                            <FormGroup className="w-md-30 w-100 px-1">
                                                <Label>هوشمند ماشين</Label>
                                                <Input value={this.state.FreighterCardNumber} maxLength={11}
                                                    onChange={(e) => this.setState({ FreighterCardNumber: e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                                            </FormGroup>
                                            {(this.props.memberType.role !== 'LoadHallAdmin') &&
                                                <FormGroup className="w-md-20 w-100 mx-1">
                                                    <Label>*سالن</Label>

                                                    <Autocomplete
                                                        clearText={"حذف"}
                                                        closeText={"بستن"}
                                                        noOptionsText={"در حال دریافت اطلاعات.."}
                                                        openText={"باز کردن"}
                                                        className="react-select__control"
                                                        id="loadHall"
                                                        options={this.state.LoadHallList}
                                                        getOptionLabel={(option) => option.name}
                                                        value={this.state.loadHall}
                                                        onChange={(e, v) => this.selectHandleChange(e, v, "loadHall")}
                                                        renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                    />
                                                </FormGroup>
                                            }
                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>وضعیت</Label>
                                                <Autocomplete
                                                    disableClearable
                                                    clearText={"حذف"}
                                                    closeText={"بستن"}
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="selectedIsActive"
                                                    options={this.state.IsActive}
                                                    getOptionLabel={(option) => option.text}
                                                    value={this.state.selectedIsActive}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "selectedIsActive")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                />
                                            </FormGroup>
                                             
                                        </div>

                                        <div className="d-flex mt-2 justify-content-center">
                                            <FormGroup className="text-center">
                                                <Button color="primary" className="btn-lg mx-2" onClick={this.SearchVirtualSalonDriverTurn}>
                                                    جستجو
                                                </Button>
                                            </FormGroup>

                                            <FormGroup className="text-center">
                                                <Button color="primary" className="btn-lg mx-2" onClick={this.clearSearch}>
                                                    پاک کردن
                                                </Button>
                                            </FormGroup>
                                        </div>
                                    </div>
                                            
                                    <Table
                                        tableHeaders={[
                                            
                                            "تاریخ ثبت",
                                            "ساعت ثبت",
                                            "نام و نام خانوادگی",
                                            "کد ملی",
                                            "شماره همراه",
                                            "هوشمند راننده",
                                            "هوشمند خودرو",
                                            "شماره پلاک",
                                            "سریال پلاک", 
                                            "نوبت",
                                            "وضعيت", 
                                            //"چاپ",
                                            "اولویت‌ها",
                                            "ابطال نوبت",
                                            
                                        ]}

                                        tableRow={this.state.DriverTurnList}

                                        tableData={[
                                            
                                            x => {
                                                return x.date
                                            },
                                            x => {
                                                return x.time
                                            },
                                            x => {
                                                return x.driverName +' ' +x.driverFamily
                                            },
                                            x => {
                                                return x.nationalId
                                            },
                                            x => {
                                                return x.mobile
                                            },
                                            x => {
                                                return x.driverCardNumber
                                            },
                                            x => {
                                                return x.freighterCardNumber
                                            },
                                            x => {
                                                return x.plaqueNumber
                                            },
                                            x => {
                                                return x.plaqueSerialNumber
                                            },
                                            x => {
                                                return x.turnNumber
                                            },
                                            x => {
                                                return x.isActive === true?'فعال':'غير فعال'
                                            },
                                            
                                            //x => {
                                            //    return (
                                            //        <Button outline color="primary" size="sm"
                                            //            onClick={() => this.print(x.id, 'pdf')}>
                                            //            چاپ
                                            //        </Button>
                                            //    )
                                            //},
                                            x => {
                                                if (this.props.memberType.role !== 'Organization' && this.props.memberType.role !== 'DriversAssociation' && this.props.memberType.role !== 'AssociationTransportCompanies') {
                                                    return (
                                                        <Button outline color="primary" size="sm"
                                                            onClick={() => this.setState({ DriverTurnId: x.id, PriorityModal: true, },
                                                                () => this.GetByDriverTurnId(x.id))}>
                                                            اولویت‌ها
                                                        </Button>
                                                    )
                                                }
                                            },
                                            x => {
                                                return (
                                                    <Button outline color="primary" size="sm"
                                                    onClick={() => this.props.showSweetAlert("آیا از ابطال نوبت اطمینان دارید؟","", "danger",()=> this.CancelDriverTurn(x.id))}>    
                                                        ابطال نوبت
                                                    </Button>
                                                )
                                            },

                                            
                                        ]}
                                    />
                                     

                                 
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Modal isOpen={this.state.PriorityModal} toggle={() => this.setState({ PriorityModal: false })} size="xlg">
                    <ModalHeader toggle={() => this.setState({ PriorityModal: false })}>
                        {this.state.priorityMsg}
                    </ModalHeader>
                    <ModalBody className="d-flex justify-content-center">
                       
                            <Table
                                tableHeaders={[
                                    "اولویت",
                                    "شناسه بار",
                                    "تاریخ ثبت",
                                    "ساعت ثبت",
                                    "فرستنده",
                                    "گیرنده", 
                                    "وضعیت", 
                                    "حذف",
                                ]}

                                tableRow={this.state.PriorityList}

                                tableData={[
                                    x => {
                                        return x.priority
                                    },
                                    x => {
                                        return x.cargoId
                                    },
                                    x => {
                                        return x.date
                                    },
                                    x => {
                                        return x.time
                                    },
                                    x => {
                                        return x.senderCustomerName
                                    },
                                    x => {
                                        return x.receiverCustomerName
                                    },
                                    x => {
                                        switch (x.status) {

                                            case 0:
                                                return <Badge color="outline-danger" pill>حذف اولویت</Badge>
                                            case 1:
                                                return <Badge color="outline-secondary" pill>ثبت اوليه</Badge>
                                            case 2:
                                                return <Badge color="outline-info" pill>رزرو بار</Badge>
                                            case 3:
                                                return <Badge color="outline-secondary" pill>لغو به وسيله رزرو</Badge>

                                        }
                                    },
                                     
                                    x => {
                                        return (
                                            <Button outline color="danger" size="sm"
                                                onClick={() => this.props.showSweetAlert("آیا این بار اتنخابی حذف شود؟", "", "danger", () => this.DeleteDriverPriority(x.driverTurnId
,x.id))}>
                                                حذف بارانتخابي
                                            </Button>
                                        )
                                    },
                                ]} />
                           
                        
                    </ModalBody>
                </Modal>
            </>
        )
    }
}
